import { useState } from "react";
import { Link } from "react-router-dom";
import api from "../api/client";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    if (!email) return;
    setBusy(true); setError(null);
    try {
      await api.post("/user/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="container" style={{ maxWidth: 400, padding: "60px 16px" }}>
      <h1 style={{ fontSize: 24, marginBottom: 8 }}>Forgot password</h1>

      {sent ? (
        <div>
          <p style={{ color: "var(--ok)", marginBottom: 16 }}>If an account with that email exists, a reset link has been sent. Check your inbox.</p>
          <Link to="/login" className="btn primary" style={{ padding: "10px 20px" }}>Back to login</Link>
        </div>
      ) : (
        <div>
          <p className="muted" style={{ marginBottom: 24 }}>Enter your email and we'll send you a link to reset your password.</p>
          <label className="muted small" style={{ display: "block", marginBottom: 4 }}>Email</label>
          <input className="input" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com" style={{ width: "100%", marginBottom: 16 }} />
          {error && <p style={{ color: "var(--bad)", fontSize: 14, marginBottom: 12 }}>{error}</p>}
          <button className="btn primary" onClick={submit} disabled={busy || !email} style={{ width: "100%", padding: 14 }}>
            {busy ? "Sending…" : "Send reset link"}
          </button>
          <p className="muted small" style={{ marginTop: 16, textAlign: "center" }}>
            <Link to="/login" style={{ color: "var(--brand)" }}>Back to login</Link>
          </p>
        </div>
      )}
    </div>
  );
}
